import React, { useEffect } from 'react';

function TabbyInfoModal({ amount, currency }) {

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.tabby.ai/tabby-promo.js';
    script.async = true;
    script.onload = () => {
      if (window.TabbyPromo) {
        new window.TabbyPromo({});
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <small
      style={{ cursor: 'pointer' }}
      className='badge badge-light'
      data-tabby-info="installments"
      data-tabby-price={amount}
      data-tabby-currency={currency}
    >
      More Options
    </small>
  );
}

export default TabbyInfoModal;
